<template>
  <div class="revit-link">
    <el-dialog
        :visible.sync="modalVisible"
        :close-on-click-modal="false"
        append-to-body
        @close="modalVisible = false"
        :title="title"
        width="400px"
        class="revit-link-dialog"
    >
      <div class="dialog-conent">
        <span>定位：</span>
        <el-select v-model="placement">
          <el-option
              v-for="item in placements"
              :key="item.value"
              :label="item.label"
              :value="item.value"
          />
        </el-select>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="modalVisible = false">取 消</el-button>
        <el-button type="primary" @click="onSubmitLink({ operate: 'Link' })" :disabled="disabledPrimary">确 定</el-button>
      </div>
    </el-dialog>
    <gjw-dialog-progress-bar ref="dialogProgressBar" @success="onStartLink" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { businessFilePath } from '@/core/desktopCache'
import GjwDialogProgressBar from '@/components/business/GjwDialogProgressBar.vue'
export default {
  components: { GjwDialogProgressBar },
  name: 'RevitLinkRVT',
  data() {
    return {
      modalVisible: false,
      placement: 'P_AUTO_ORIGIN',
      placements: [
        {
          value: 'P_AUTO_ORIGIN',
          label: '自动 - 原点到原点',
        }],
      linkFilePath: '',
      disabledPrimary: false,
      spaceId: this.$route.params.spaceId,
      title: '',
      linkObject: {},
      currentRecord: null
    }
  },
  computed: {
    ...mapGetters({
      user: 'user/user',
      softwareCode: 'softwareCode',
      softwareVersion: 'softwareVersion',
      clientType: 'platform',
      isCapitalSoftware: 'isCapitalSoftware',
    }),
    withoutUI() {
      return this.isCapitalSoftware
    },
  },
  methods: {
    async onRevitLink(linkObject, title) {
      // 判断数据是否为可以进行链接
      if (!linkObject) {
        this.$message.error('请选择需要链接的文件。')
        return
      }
      this.title = title
      this.linkObject = linkObject
      const data = await this.$api.file.getVersionRecords(this.spaceId, linkObject.id)
      if (data) {
        const record = data.revisionRecords.find((f) => f.status === true)
        this.currentRecord = record
        if (this.clientType === 'g' && !this.withoutUI) {
          // 对于解析成功的文件，数维插件需要校验软件版本是否≤当前设计环境的软件版本
          const continueFlag = ['PROCESSING', 'FAILED'].includes(linkObject.parseStatus) ? true : record.softwareVersion && record.softwareVersion <= this.softwareVersion
          if (continueFlag) {
            await this.link(linkObject.id)
          } else {
            this.$confirm('该文件由更高版本软件制作，无法链接', {
              cancelButtonText: '确定',
              showConfirmButton: false,
              showClose: false,
              type: 'error',
            }).catch()
            this.modalVisible = false
          }
        } else {
          await this.link(linkObject.id)
        }
      }
    },

    async link(fileId) {
      const linkFilePath = await businessFilePath(this.user.strId, fileId)
      this.linkFilePath = linkFilePath
      // 插件接口，文件所在目录获取模型链接
      try {
        const linkByDesktop = await this.$desktopClient.ListModelLinksByDirPath(linkFilePath)
        if (linkByDesktop && linkByDesktop.code === 'success') {
          if (linkByDesktop.data && linkByDesktop.data.length > 0) {
            // 更新
            this.$confirm('已链接该文件，是否更新到最新？', {
              confirmButtonText: '更新',
              cancelButtonText: '取消',
              showClose: false,
              type: 'info',
            }).then(() => {
              // 更新逻辑
              this.updateLink(linkByDesktop.data[0])
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消更新链接',
              })
            })
          } else {
            // 链接
            if (this.withoutUI) {
              await this.onSubmitLink({ operate: 'Link' })
            } else {
              this.modalVisible = true
            }
          }
        } else {
          this.disabledPrimary = true
          this.$message.error('插件获取端软件链接信息失败！')
        }
      } catch (err) {
        console.log(err)
      }
    },
    async onSubmitLink(operation) {
      this.modalVisible = false
      this.$refs.dialogProgressBar && this.$refs.dialogProgressBar.init(this.spaceId, this.getFilePath(), this.linkObject, operation)
    },
    async onStartLink(operation) {
      if (['r', 'g'].includes(this.clientType)) {
        const eventName = this.linkObject.fileType === 'GMC' ? 'linkSpaceGMC' : this.clientType === 'r' ? 'linkSpaceRModelLink' : 'linkSpaceGModelLink'
        this.$tracks({
          event: eventName,
          params: {
            g_c_space_id: this.spaceId,
            g_c_file_id: this.linkObject.id,
          }
        })
      }
      if (operation.operate === 'Link') {
        const params = {
          userId: this.user.strId, // Long, 用户ID
          fileId: this.linkObject.id, // Long, 文件ID
          fileRevisionId: this.currentRecord.fileRevisionId, // Long, 文件修订版本ID
          filePath: this.getFilePath(), // String, 文件路径
        }
        if (!this.withoutUI) {
          params.placement = this.placement
        }
        await this.$desktopClient.LinkModel(params)
      } else if (operation.operate === 'Reload') {
        await this.$desktopClient.ReloadModelLink(operation.linkId, {
          options: {
            userId: this.user.strId, // Long, 用户ID
            fileId: this.linkObject.id, // Long, 文件ID
            fileRevisionId: this.currentRecord.fileRevisionId, // Long, 文件修订版本ID
          }
        })
      } else if (operation.operate === 'ReloadFrom') {
        await this.$desktopClient.ReloadModelLinkFrom(this.getFilePath(), operation.linkId, {
          userId: this.user.strId, // Long, 用户ID
          fileId: this.linkObject.id, // Long, 文件ID
          fileRevisionId: this.currentRecord.fileRevisionId, // Long, 文件修订版本ID
        })
      }
    },
    async updateLink(linkByDesktop) {
      // 模型链接ElementId
      const linkId = linkByDesktop.linkId
      // 判断链接记录中本地文件是否存在 this.getFilePath()
      const existFile = await this.$desktopClient.ExistFile(linkByDesktop.linkPath)
      if (existFile.code === 'success' && existFile.data === true) {
        // 链接记录中本地文件存在，判断md5是否一致？
        const fileMd5 = await this.$desktopClient.GetFileMd5(this.getFilePath())
        if (fileMd5.data === this.currentRecord.md5) {
          this.$confirm('当前链接的已经是最新版本了。', {
            confirmButtonText: '确定',
            showCancelButton: false,
            showClose: false,
            type: 'info',
          }).catch()
        } else {
          // md5不一致, 看名称是否一致
          const operate = linkByDesktop.linkPath === this.getFilePath() ? 'Reload' : 'ReloadFrom'
          this.onSubmitLink({ operate: operate, linkId }).catch()
        }
      } else {
        // 本地文件不存在, 下载缓存并链接
        const operate = linkByDesktop.linkPath === this.getFilePath() ? 'Reload' : 'ReloadFrom'
        this.onSubmitLink({ operate: operate, linkId }).catch()
      }
    },
    getFilePath() {
      return this.linkFilePath + '\\' + this.linkObject.name + '.' + this.linkObject.suffix
    }
  }
}

</script>
<style>
.revit-link-dialog .el-dialog__footer {
  padding: unset !important;
}
</style>
<style lang="less" scoped>
.el-dialog {
  .dialog-conent {
    display: flex;
    justify-content: center;
    align-items: center;
    .el-select {
      flex: 1;
    }
  }
  .dialog-footer {
    padding: 15px 20px;
    border-top: 1px solid @border-color-tag;
  }
}

/deep/ .el-checkbox__input.is-checked+.el-checkbox__label {
  color: #495F70 !important;
}
</style>
